// useful for humanzing object keys, i.e. :
// foo_bar        -> Foo bar
// foo-bar        -> Foo-bar
// foo_bar_baz    -> Foo bar baz
// this is a test -> This is a test
// foo Bar Baz    -> Foo bar baz
// fooBarBaz      -> FooBarBaz
export function humanize(str) {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, (m) => m.toUpperCase());
}
